import { isFeatureFlagEnabled } from './isFeatureFlagEnabled';

export const isUserPermissionOrFeatureFlagEnabled = (
    permissions,
    selectedAccountConfig,
    requiredPermissions,
    featureFlagEnabled
) => permissions[requiredPermissions] || isFeatureFlagEnabled(selectedAccountConfig, featureFlagEnabled);
